<script>
export default {
  name: "ShutdownBanner"
};
</script>

<template>
  <div class="alert alert-warning text-center m-0 shutdown-banner">
    <strong>Important:</strong>
    The ReDem 2.0 App will be shut down on <strong>15.12.2025</strong>.
    Please migrate to the ReDem 3.0 App and export any existing projects you need,
    as they will no longer be accessible after the shutdown.
    <a
      href="https://app.beta.redem.io"
      target="_blank"
      rel="noopener noreferrer"
      class="btn btn-sm btn-dark ml-3"
    >
      Go to ReDem 3.0
    </a>
  </div>
</template>

<style scoped>
.shutdown-banner {
  border-radius: 0;
}
</style>


